import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, MessageSquare, User2 } from 'lucide-react';

import PaymentsTabIcon from '../../assets/svgComponents/PaymentsTabIcon';
import urls from '../../routing/urls';

import styles from './MobileNavigation.module.scss';

const MobileNavigation = () => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = useMemo(() => {
    if (location.pathname === '/') {
      return 'payments';
    }
    const pathSegment = location.pathname.split('/')[1];
    if (pathSegment === 'jobs' || pathSegment === 'browse') {
      return 'browse';
    }
    return pathSegment;
  }, [location.pathname]);

  const getTabStyles = useCallback(
    (tab) => {
      if (activeTab === tab) {
        return `${styles.tab} ${styles.active}`;
      }
      return `${styles.tab} ${styles.inactive}`;
    },
    [activeTab]
  );

  const handleNavigation = (tab, path) => {
    localStorage.setItem('activeTab', tab);
    navigate(path);
  };

  const navigateToPaymentTab = () => handleNavigation('payments', urls.payments);
  const navigateToAccountTab = () => handleNavigation('account', urls.profile);
  const navigateToBrowseTab = () => handleNavigation('browse', urls.browse);
  const navigateToDashboardTab = () => handleNavigation('dashboard', urls.dashboard);

  return (
    <div className={styles.container}>
      <div className={getTabStyles('payments')} onClick={navigateToPaymentTab} role="presentation">
        <div className={styles.iconCont}>
          <PaymentsTabIcon />
        </div>
        <p className={styles.tabsLabel}>{t('navigation.payments')}</p>
      </div>
      <div className={getTabStyles('browse')} onClick={navigateToBrowseTab} role="presentation">
        <div className={styles.iconCont}>
          <MessageSquare />
        </div>
        <p className={styles.tabsLabel}>{t('navigation.browse')}</p>
      </div>
      <div className={getTabStyles('dashboard')} onClick={navigateToDashboardTab} role="presentation">
        <div className={styles.iconCont}>
          <LayoutDashboard />
        </div>
        <p className={styles.tabsLabel}>{t('navigation.dashboard')}</p>
      </div>
      <div className={getTabStyles('account')} onClick={navigateToAccountTab} role="presentation">
        <div className={styles.iconCont}>
          <User2 />
        </div>
        <p className={styles.tabsLabel}>{t('navigation.account')}</p>
      </div>
    </div>
  );
};

export default MobileNavigation;
